import React from 'react';
import { Mail, Instagram, Facebook, Linkedin, Lock, Headphones, Truck, Package } from 'lucide-react';
import { businessInfo } from '../mock';

// Custom Google icon component
const GoogleIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
  </svg>
);

// Custom Yelp icon component
const YelpIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M21.111 18.226c-.141.969-2.119 3.483-3.029 3.847-.311.124-.611.094-.85-.09-.154-.12-.314-.365-2.447-3.827l-.633-1.032c-.244-.37-.199-.857.104-1.229.297-.37.756-.494 1.163-.314l1.156.534c3.674 1.692 4.227 1.996 4.347 2.111z"/>
    <path d="M15.93 12.241c.256-.355.728-.452 1.15-.244l1.186.571c3.596 1.744 4.144 2.045 4.253 2.165.252.268.303.594.249.907-.144.967-2.104 3.498-3.001 3.878-.311.131-.618.108-.861-.061-.155-.113-.322-.344-2.559-3.737l-.646-1.011c-.256-.381-.214-.858.123-1.229.068-.075.106-.149.106-.239z"/>
    <path d="M12.744 17.803l.097 1.313c.276 3.936.276 4.535.239 4.699-.08.336-.306.54-.612.641-.959.316-4.163-.535-4.763-1.258-.206-.249-.265-.541-.196-.847.046-.191.193-.484 1.836-3.722l.508-.993c.199-.367.625-.529 1.052-.404.424.124.739.493.758.942l.013.325c.02.431.048.885.068 1.304z"/>
    <path d="M11.301 10.649c.004.533-.396.984-.924 1.041l-1.313.142c-3.934.426-4.531.442-4.696.406-.34-.072-.551-.29-.664-.588-.345-.949.429-4.178 1.123-4.805.239-.216.527-.285.839-.226.193.037.496.171 3.794 1.693l1.011.465c.38.177.605.571.604.984l.003.342c.005.193.022.36.023.546z"/>
    <path d="M12.729 8.998c-.39.199-.869.085-1.143-.273l-.802-1.049C8.062 4.312 7.779 3.783 7.73 3.611c-.106-.329-.021-.633.2-.869.696-.746 3.841-1.659 4.817-1.398.336.09.559.302.678.601.073.184.139.497.357 4.573l.078 1.253c.033.422-.186.833-.576 1.031l-.286.142c-.089.044-.179.036-.269.054z"/>
  </svg>
);

const Footer = () => {
  return (
    <footer>
      {/* Features bar - cream background */}
      <div className="bg-[#f5f0e8]">
        <div className="container mx-auto px-4 py-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="flex items-center justify-center gap-3">
              <div className="w-12 h-12 bg-[#ebe5db] rounded-full flex items-center justify-center">
                <Lock className="w-5 h-5 text-gray-600" />
              </div>
              <span className="text-sm font-medium text-gray-700">Secure payment</span>
            </div>
            <div className="flex items-center justify-center gap-3">
              <div className="w-12 h-12 bg-[#ebe5db] rounded-full flex items-center justify-center">
                <Headphones className="w-5 h-5 text-gray-600" />
              </div>
              <span className="text-sm font-medium text-gray-700">Customer support</span>
            </div>
            <div className="flex items-center justify-center gap-3">
              <div className="w-12 h-12 bg-[#ebe5db] rounded-full flex items-center justify-center">
                <Truck className="w-5 h-5 text-gray-600" />
              </div>
              <span className="text-sm font-medium text-gray-700">24-hour delivery</span>
            </div>
            <div className="flex items-center justify-center gap-3">
              <div className="w-12 h-12 bg-[#ebe5db] rounded-full flex items-center justify-center">
                <Package className="w-5 h-5 text-gray-600" />
              </div>
              <span className="text-sm font-medium text-gray-700">Free shipping</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main footer - cream/beige background */}
      <div className="bg-[#faf7f2]">
        <div className="container mx-auto px-4 py-12">
          <div className="grid md:grid-cols-4 gap-8">
            {/* Brand with Logo */}
            <div className="text-center md:text-left">
              <h3 className="text-xl font-bold mb-2 text-gray-900">STREETSVILLE</h3>
              <h3 className="text-xl font-bold mb-4 text-gray-900">EYECARE</h3>
              <img 
                src="https://lirp.cdn-website.com/1d57ed00/dms3rep/multi/opt/Streetsville+Eyecare+Logo+Full-1920w.png"
                alt="Streetsville Eyecare"
                className="h-24 mx-auto md:mx-0 mb-4"
              />
              {/* Colorful Social Icons */}
              <div className="flex gap-2 justify-center md:justify-start mb-4">
                <a href="https://mail.google.com/mail/?view=cm&to=streetsvilleeyecare@gmail.com" target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-gray-500 rounded-full flex items-center justify-center hover:opacity-80 transition-opacity">
                  <Mail className="w-4 h-4 text-white" />
                </a>
                <a href={businessInfo.social.instagram} target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-gradient-to-br from-purple-500 via-pink-500 to-orange-400 rounded-full flex items-center justify-center hover:opacity-80 transition-opacity">
                  <Instagram className="w-4 h-4 text-white" />
                </a>
                <a href={businessInfo.social.facebook} target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center hover:opacity-80 transition-opacity">
                  <Facebook className="w-4 h-4 text-white" />
                </a>
                <a href="https://www.google.com/search?q=Streetsville+Eyecare" target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center hover:opacity-80 transition-opacity">
                  <GoogleIcon className="w-4 h-4 text-white" />
                </a>
                <a href={businessInfo.social.linkedin} target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-blue-700 rounded-full flex items-center justify-center hover:opacity-80 transition-opacity">
                  <Linkedin className="w-4 h-4 text-white" />
                </a>
                <a href="https://www.yelp.ca/biz/streetsville-eyecare-mississauga" target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-red-600 rounded-full flex items-center justify-center hover:opacity-80 transition-opacity">
                  <YelpIcon className="w-4 h-4 text-white" />
                </a>
              </div>
              <p className="text-xs text-gray-500">© 2026 All Rights Reserved | Streetsville Eyecare</p>
            </div>

            {/* Location */}
            <div className="text-center">
              <h4 className="font-bold mb-4 text-gray-900 text-lg">LOCATION</h4>
              <div className="text-gray-700 text-sm space-y-1">
                <p>{businessInfo.address.street}</p>
                <p>{businessInfo.address.unit}</p>
                <p>{businessInfo.address.city}, {businessInfo.address.province}</p>
                <p>{businessInfo.address.postalCode}</p>
                <p className="pt-4">
                  <a href={`tel:${businessInfo.phone}`} className="text-red-600 hover:underline font-medium">{businessInfo.phone}</a>
                </p>
                <p>
                  <a href="https://mail.google.com/mail/?view=cm&to=streetsvilleeyecare@gmail.com" target="_blank" rel="noopener noreferrer" className="text-red-600 hover:underline">streetsvilleeyecare@gmail.com</a>
                </p>
              </div>
            </div>

            {/* Directions with Map */}
            <div className="text-center">
              <h4 className="font-bold mb-4 text-gray-900 text-lg">DIRECTIONS</h4>
              <div className="rounded-lg overflow-hidden shadow-md">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2889.5!2d-79.7264322!3d43.58243!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b43a95a2b1c7d%3A0x8a5c6c0e2b3c4d5e!2sStreetsville%20EyeCare!5e0!3m2!1sen!2sca!4v1234567890"
                  width="100%"
                  height="180"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Streetsville Eyecare Location"
                ></iframe>
              </div>
            </div>

            {/* Business hours */}
            <div className="text-center md:text-left">
              <h4 className="font-bold mb-4 text-gray-900 text-lg">BUSINESS HOURS</h4>
              <div className="text-gray-700 text-sm space-y-1">
                {businessInfo.hours.map((hour, index) => (
                  <div key={index} className="flex justify-between md:justify-start gap-4">
                    <span className="font-medium w-24">{hour.day}</span>
                    <span>{hour.hours}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Black bottom bar */}
      <div className="bg-gray-900 py-4">
        <div className="container mx-auto px-4 text-center">
          <div className="flex justify-center">
            <img 
              src="https://lirp.cdn-website.com/1d57ed00/dms3rep/multi/opt/Streetsville+Eyecare+Logo+Full-1920w.png"
              alt="Streetsville Eyecare"
              className="h-12 opacity-30"
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
